HttpCacheConfig.$inject = ['$httpProvider'];
export function HttpCacheConfig($httpProvider) {
    $httpProvider.interceptors.push('CachingHttpInterceptor');
}

import { ICacheFactoryService, IRequestConfig } from 'angular';

declare module 'angular' {
    interface IRequestShortcutConfig {
        ttl?: number;
    }
}

export function CachingHttpInterceptorFactory(
    $cacheFactory: ICacheFactoryService
) {
    // track request times for cache expiration, using a cache for the convenice of removeAll.
    // note: the user service is used to clear the cache on login/logout.
    const $httpRequestTimeCache = $cacheFactory('$httpRequestTime');

    return {
        // cache on request to deduplicate similar requests.
        request: (config: IRequestConfig) => {
            if (config.method !== 'GET') {
                return config;
            }

            const ttl = config.ttl;
            if (ttl == undefined) return config;
            // note: the user service is used to clear the cache on login/logout.
            const $httpCache = $cacheFactory.get('$http');
            if (!$httpCache) {
                console.warn('httpCache not found', {
                    config,
                    $cacheFactory,
                    cache: $httpCache,
                });
                return config;
            }

            // enable cache if ttl is set
            config.cache = true;
            const timestamp = new Date().getTime();
            const _cacheTime = $httpRequestTimeCache.get(config.url) as number;

            // if it is cached and it is expired, remove it so a new request will be sent.
            if (_cacheTime && timestamp - _cacheTime > ttl) {
                // note: the user service is used to clear the cache on login/logout.
                $httpCache.remove(config.url);
                $httpRequestTimeCache.put(config.url, timestamp);
            }
            return config;
        },
    };
}
CachingHttpInterceptorFactory.$inject = ['$cacheFactory'];
